// no-submitter.js
;(({ $, $$, log}) => {
    $$('form').forEach(form => {
        form.addEventListener('submit', event => {
            const { submitter } = event
            if (submitter.classList.contains('js-no-submitter')) {
                event.preventDefault()
            }
        })
    })
})(CNS);